module.exports = __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.2928664f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/component/util/svg/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg
// module id = 27
// module chunks = 0